import { PlatformType } from '../platform_type';
export interface IntegrateState {
  platform: PlatformType;
  platformErrors: Array<string>;
  shopifyDeeplink: string;
  hasWidgetV3: boolean;
}

export const initialIntegrateState: IntegrateState = {
  platform: PlatformType.Other,
  platformErrors: [],
  shopifyDeeplink: undefined,
  hasWidgetV3: false
};
